import { render, staticRenderFns } from "./ControlPermisos.vue?vue&type=template&id=e8cac776&lang=pug"
import script from "./ControlPermisos.vue?vue&type=script&lang=js"
export * from "./ControlPermisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports